import { render } from "./PlayerGameReport.vue?vue&type=template&id=7b065766&scoped=true"
import script from "./PlayerGameReport.vue?vue&type=script&lang=js"
export * from "./PlayerGameReport.vue?vue&type=script&lang=js"

import "./PlayerGameReport.vue?vue&type=style&index=0&id=7b065766&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b065766"]])

export default __exports__